module.exports = __webpack_public_path__ + "img/05-cross-02.37a484f5.svg";